import React from 'react';
import { IconButton, Stack } from '@mui/material';
import List from '@mui/material/List';
import AppScrollbar from '@crema/core/AppScrollbar';
import NotificationItem from './NotificationItem';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { EditOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { onGetWidgetsData } from 'redux/actions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppTooltip from '../AppTooltip';
import { alpha } from '@mui/material/styles';
import FormDialog from 'pages/sample/FormDialog/FormDialog';
import { onGetAnnouncement } from 'redux/actions/Portal';
import { TablePagination } from '@mui/material';
const AppNotificationContent = ({ onClose, sxStyle }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);

  const handleNextPage = (e, page) => {
    setPage(page);
    dispatch(onGetAnnouncement(page + 1));
  };

  useEffect(() => {
    dispatch(onGetWidgetsData());
    dispatch(onGetAnnouncement());
  }, [dispatch]);

  const [announcement] = useSelector(
    ({ portal }) => [
      // dashboard.widgetsData,
      portal.announcement
    ]
  );

  const [localAnnouncement, setLocalAnnouncement] = useState(announcement);
  useEffect(() => {
    setLocalAnnouncement(announcement);
  }, [announcement]);
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: 280,
          height: '100%',
          ...sxStyle,
        }}
      >
        <Box
          sx={{
            padding: '5px 20px',
            display: 'flex',
            alignItems: 'center',
            borderBottom: 1,
            borderBottomColor: (theme) => theme.palette.divider,
            minHeight: { xs: 56, sm: 70 },
          }}
        >
          <Typography component='h3' variant='h3'>
            Pengumuman
          </Typography>
          <AppTooltip title="Buat Pengumuman">
            <IconButton
              sx={{
                height: 40,
                width: 40,
                marginLeft: 'auto',
                color: 'text.secondary',
                backgroundColor: (theme) => theme.palette.background.default,
                border: 1,
                borderColor: 'transparent',
                '&:hover, &:focus': {
                  color: (theme) => theme.palette.text.primary,
                  backgroundColor: (theme) =>
                    alpha(theme.palette.background.default, 0.9),
                  borderColor: (theme) =>
                    alpha(theme.palette.text.secondary, 0.25),
                },
              }}
              onClick={handleClickOpen}
              size='large'
            >
              <EditOutlined />
            </IconButton>
          </AppTooltip>
          <AppTooltip title='Tutup'>
            <IconButton
              sx={{
                height: 40,
                width: 40,
                marginLeft: 'auto',
                color: 'text.secondary',
                backgroundColor: (theme) => theme.palette.warning.light,
                border: 1,
                borderColor: 'transparent',
                '&:hover, &:focus': {
                  color: (theme) => theme.palette.text.primary,
                  backgroundColor: (theme) =>
                    alpha(theme.palette.background.default, 0.9),
                  borderColor: (theme) =>
                    alpha(theme.palette.text.secondary, 0.25),
                },
              }}
              onClick={onClose}
              size='large'
            >
              <CancelOutlinedIcon />
            </IconButton>
          </AppTooltip>
        </Box>
        {
          localAnnouncement.results?.length === 0 ? (
            <Stack alignItems={'center'} justifyContent={'center'} height={'100% !important'}>
              <Typography>Tidak ada pengumuman</Typography>
            </Stack>
          ) :
            (
              <AppScrollbar
                sx={{
                  height: { xs: 'calc(100% - 96px)', sm: 'calc(100% - 110px)' },
                }}
              >
                <List sx={{ py: 0 }}>
                  {
                    localAnnouncement.results.map((item) => (
                      <NotificationItem key={item.id} item={item} />
                    ))
                  }
                </List>
              </AppScrollbar>
            )
        }
        {/* <Button
          sx={{
            borderRadius: 0,
            width: '100%',
            textTransform: 'capitalize',
            marginTop: 'auto',
            height: 40,
          }}
          variant='contained'
          color='primary'
        >
          
        </Button> */}
        <FormDialog open={open} handleClose={handleClose}></FormDialog>
        <TablePagination
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
          rowsPerPageOptions={[]}
          component="div"
          count={announcement.count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleNextPage}
          labelDisplayedRows={({ from, to, count }) =>
            ` ${from}-${to} dari ${count}`
          }
        // onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </>

  );
};

export default AppNotificationContent;

AppNotificationContent.propTypes = {
  onClose: PropTypes.func,
  sxStyle: PropTypes.object,
};
